import React, { useEffect, useState } from "react";

const Loader = () => {
  const [logo, setLogo] = useState("/img/flipkart-logo.webp");
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch("/webcontrollerdata.json");
        const data = await res.json();

        if (data.loaderEnabled !== undefined) setEnabled(data.loaderEnabled);
        if (data.loaderLogo) setLogo(data.loaderLogo);
      } catch (err) {
        console.error("Error loading JSON config:", err);
      }
    };
    fetchConfig();
  }, []);

  if (!enabled) return null;

  return (
    <div className="page-loader">
      <div className="loader-content">
        <img src={logo} alt="Logo" className="loader-logo" />
      </div>
    </div>
  );
};

export default Loader;
